export default "__VITE_ASSET__DrkZzi7E__"